module.exports = __webpack_public_path__ + "img/IMG_2893.f930fd38.jpg";